import { defineMessage } from 'services/localization';

export const messages = {
    instruction: defineMessage('enter_the_digit_authent_our_approvalmax_account'),
    codeFieldTitle: defineMessage('alternative_email_address'),
    invalidEmailErrorText: defineMessage('this_email_address_is_not_valid'),
    emailLabel: defineMessage('email'),
    emailPlaceholder: defineMessage('enter_an_alternative_email_address'),
    nextButton: defineMessage('send_me_the_code'),
};
